import { IconSparkle } from '@vtex/shoreline'

import SelectSearchable from '~/components/SelectSearchable'

import styles from './styles.module.css'

export type SelectOptionItem = { label: string; value: string }

type OptionSelectProps = {
  placeholder: string
  options: SelectOptionItem[]
  /** Valor selecionado; a conversão para a opção do select fica aqui. */
  value?: string | null
  isClearable?: boolean
  /** `suggested` destaca a linha cujo valor veio de uma sugestão ainda não revisada. */
  tone?: 'default' | 'suggested'
  /** Texto da opção que cria um valor novo; sem ele, só as opções valem. */
  createLabel?: (input: string) => string
  onChange: (option: SelectOptionItem | null) => void
}

const PURPLE_BORDER =
  '1px solid color-mix(in srgb, var(--sl-color-purple-11) 24%, transparent)'
const PURPLE_BACKGROUND =
  'color-mix(in srgb, var(--sl-color-purple-11) 8%, transparent)'

/**
 * `border` e `background` por extenso: o `SelectSearchable` aplica as mesmas
 * abreviadas depois destas e reporia a cor se viessem só como `borderColor` e
 * `backgroundColor`. O recuo do valor acompanha as medidas do ícone no CSS.
 */
const suggestedStyles = {
  control: (base: Record<string, unknown>) => ({
    ...base,
    border: PURPLE_BORDER,
    background: PURPLE_BACKGROUND,
    '&:hover': { border: PURPLE_BORDER }
  }),
  valueContainer: (base: Record<string, unknown>) => ({
    ...base,
    paddingLeft:
      'calc(var(--suggested-icon-left) + var(--suggested-icon-size) + var(--sl-space-2))'
  })
}

/**
 * `SelectSearchable` é JS: as props inferidas exigem campos que estas telas não
 * usam. Este wrapper concentra o único ponto de conversão de tipos.
 */
const Select = SelectSearchable as unknown as React.FC<Record<string, unknown>>

export const OptionSelect: React.FC<OptionSelectProps> = ({
  placeholder,
  options,
  value,
  isClearable = true,
  tone = 'default',
  createLabel,
  onChange
}) => {
  const isSuggested = tone === 'suggested'

  const select = (
    <Select
      placeholder={placeholder}
      options={options}
      value={value ? [{ label: value, value }] : null}
      isClearable={isClearable}
      styles={isSuggested ? suggestedStyles : undefined}
      creatable={!!createLabel}
      formatCreateLabel={createLabel}
      onChange={onChange}
    />
  )

  if (!isSuggested) return select

  return (
    <span className={styles.suggestedSelect}>
      <IconSparkle className={styles.suggestedIcon} aria-hidden="true" />
      {select}
    </span>
  )
}
